import { useMutation, useQueryClient } from '@tanstack/react-query'
import api from '../../api'
import type { MongoDBDetailsUpdateRequest } from '../../types/mongodb'

const useUpdateMongoDBDetails = (mongoDBID: string) => {
	const queryClient = useQueryClient()

	return useMutation({
		mutationFn: (request: MongoDBDetailsUpdateRequest) =>
			api.mongodb.updateMongoDBDetails(request),
		onSuccess: () => {
			void queryClient.invalidateQueries({ queryKey: ['mongodb'], exact: true })
			void queryClient.invalidateQueries({ queryKey: ['mongodb', mongoDBID] })
			void queryClient.invalidateQueries({ queryKey: ['mongodb-eligibility'] })
		}
	})
}

export default useUpdateMongoDBDetails
